export { default } from 'shared/components/context/content'
